module.exports = __webpack_public_path__ + "static/Tomer-16da66c8d7ebf86a4729bff1e525b529.jpeg";